import { FILTER_CONTROLS } from 'site-modules/lease-deals/components/filters/infrastructure/filters-controls';
import { FILTER_QUERY_PARAMS } from 'site-modules/shared/constants/lease-deals/lease-deals';

const BODY_TYPE = 'BODY_TYPE';
const MAKE = 'MAKE';
const ENGINE_TYPE = 'ENGINE_TYPE';
const LOCATION_ZIP = 'LOCATION_ZIP';
const MONTHLY_PAYMENT = 'MONTHLY_PAYMENT';
const DUE_AT_SIGNING = 'DUE_AT_SIGNING';
const SORT_BY = 'SORT_BY';
const SORT_BY_HEADER = 'SORT_BY_HEADER';
const TERM = 'TERM';
const MILEAGE_ALLOWANCE = 'MILEAGE_ALLOWANCE';
const TOTAL_SEATING = 'TOTAL_SEATING';

export const FILTER_DEFINITIONS = {
  [LOCATION_ZIP]: {
    title: 'Location',
    control: FILTER_CONTROLS.ZIP_INPUT,
    controlProps: {},
  },
  [BODY_TYPE]: {
    title: 'Body type',
    control: FILTER_CONTROLS.CHECKBOX_PILL,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.BODY_TYPE,
      dataKey: FILTER_QUERY_PARAMS.BODY_TYPE,
      classNames: 'd-flex flex-wrap gap-0_75 px-1_5',
    },
  },
  [MONTHLY_PAYMENT]: {
    title: 'Monthly payment',
    control: FILTER_CONTROLS.MONTHLY_PAYMENT,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.MONTHLY_PAYMENT,
      dataKey: FILTER_QUERY_PARAMS.MONTHLY_PAYMENT,
    },
  },
  [MAKE]: {
    title: 'Make',
    control: FILTER_CONTROLS.CHECKBOX_TRACKED,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.MAKE,
      dataKey: FILTER_QUERY_PARAMS.MAKE,
    },
  },
  [DUE_AT_SIGNING]: {
    title: 'Due at Signing',
    control: FILTER_CONTROLS.MONTHLY_PAYMENT,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.DUE_AT_SIGNING,
      dataKey: FILTER_QUERY_PARAMS.DUE_AT_SIGNING,
    },
  },
  [ENGINE_TYPE]: {
    title: 'Fuel type',
    control: FILTER_CONTROLS.CHECKBOX_PILL,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.ENGINE_TYPE,
      dataKey: FILTER_QUERY_PARAMS.ENGINE_TYPE,
      classNames: 'd-flex flex-wrap gap-0_75 px-1_5',
    },
  },
  [TERM]: {
    title: 'Term',
    control: FILTER_CONTROLS.CHECKBOX_PILL,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.TERM,
      dataKey: FILTER_QUERY_PARAMS.TERM,
      classNames: 'd-flex flex-wrap gap-0_75 px-1_5',
    },
  },
  [MILEAGE_ALLOWANCE]: {
    title: 'Mileage allowance',
    control: FILTER_CONTROLS.CHECKBOX_PILL,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.MILEAGE_ALLOWANCE,
      dataKey: FILTER_QUERY_PARAMS.MILEAGE_ALLOWANCE,
      classNames: 'd-flex flex-wrap gap-0_75 px-1_5',
    },
  },
  [TOTAL_SEATING]: {
    title: 'Total seating',
    control: FILTER_CONTROLS.CHECKBOX_TRACKED,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.TOTAL_SEATING,
      dataKey: FILTER_QUERY_PARAMS.TOTAL_SEATING,
    },
  },
  [SORT_BY]: {
    title: 'Sort by',
    control: FILTER_CONTROLS.SORT_BY,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.SORT_BY,
      dataKey: FILTER_QUERY_PARAMS.SORT_BY,
    },
  },
  [SORT_BY_HEADER]: {
    title: 'Sort by',
    control: FILTER_CONTROLS.SORT_BY_HEADER,
    controlProps: {
      optionsKey: FILTER_QUERY_PARAMS.SORT_BY,
      dataKey: FILTER_QUERY_PARAMS.SORT_BY,
    },
  },
};

export const FILTERS_LAYOUT_DESKTOP = [
  {
    groupId: 'location',
    title: 'Location',
    isCollapsible: false,
    items: [{ id: LOCATION_ZIP, innerGroupClassName: 'text-cool-gray-10 size-20 fw-medium px-1_5' }],
  },
  {
    groupId: 'bodyType',
    title: 'Body type',
    isCollapsible: true,
    isOpenOnLoad: true,
    items: [{ id: BODY_TYPE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'monthlyPayment',
    title: 'Monthly payment',
    isCollapsible: true,
    isOpenOnLoad: true,
    items: [{ id: MONTHLY_PAYMENT, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'make',
    title: 'Make',
    isCollapsible: true,
    isOpenOnLoad: true,
    items: [{ id: MAKE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'engineType',
    title: 'Fuel type',
    isCollapsible: true,
    isOpenOnLoad: true,
    items: [{ id: ENGINE_TYPE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'dueAtSigning',
    title: 'Due at signing',
    isCollapsible: true,
    isOpenOnLoad: true,
    items: [{ id: DUE_AT_SIGNING, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'term',
    title: 'Term',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: TERM, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'mileageAllowance',
    title: 'Mileage allowance',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: MILEAGE_ALLOWANCE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'totalSeating',
    title: 'Total seating',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: TOTAL_SEATING, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'sortBy',
    title: 'Sort by',
    isCollapsible: true,
    isOpenOnLoad: false,
    hideCollapseSeparator: true,
    items: [{ id: SORT_BY, innerGroupClassName: 'visually-hidden' }],
  },
];

export const FILTERS_LAYOUT_MOBILE = [
  {
    groupId: 'location',
    title: 'Location',
    isCollapsible: false,
    items: [{ id: LOCATION_ZIP, innerGroupClassName: 'text-cool-gray-10 size-20 fw-medium px-1_5' }],
  },
  {
    groupId: 'bodyType',
    title: 'Body type',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: BODY_TYPE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'monthlyPayment',
    title: 'Monthly payment',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: MONTHLY_PAYMENT, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'make',
    title: 'Make',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: MAKE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'engineType',
    title: 'Fuel type',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: ENGINE_TYPE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'dueAtSigning',
    title: 'Due at signing',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: DUE_AT_SIGNING, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'term',
    title: 'Term',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: TERM, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'mileageAllowance',
    title: 'Mileage allowance',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: MILEAGE_ALLOWANCE, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'totalSeating',
    title: 'Total seating',
    isCollapsible: true,
    isOpenOnLoad: false,
    items: [{ id: TOTAL_SEATING, innerGroupClassName: 'visually-hidden' }],
  },
  {
    groupId: 'sortBy',
    title: 'Sort by',
    isCollapsible: true,
    isOpenOnLoad: false,
    hideCollapseSeparator: true,
    items: [{ id: SORT_BY, innerGroupClassName: 'visually-hidden' }],
  },
];
